import React, { useState } from "react";
import notecontext from "./Notecontext";
const host = "https://fullstack-backend-mtio.onrender.com";
const Notestate = (props) => {
const notesinitial = [];
const [notes, setnotes] = useState(notesinitial);

// GET ALL NOTES----------------------------------------------------------------------------------------------------------------------------------------------

  const getnotes = async () => {
    const response = await fetch(`${host}/api/notes/fetchallnotes`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "auth-token": localStorage.getItem("token"),
      },
    });
    const json = await response.json()
    console.log(json);
    setnotes(json)
  };

// ADD ALL NOTES----------------------------------------------------------------------------------------------------------------------------------------

  const addnote = async (title, description, tag) => {
    const response = await fetch(`${host}/api/notes/addnote`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "auth-token": localStorage.getItem("token"),
      },
      body: JSON.stringify({title, description, tag}),
    });
    const note = await response.json();
    setnotes(notes.concat(note));
  };

 // DELETE NOTES-------------------------------------------------------------------------------------------------------------------------------------- 

  const deletenote = async(id) => {
    const response = await fetch(`${host}/api/notes/delete/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "auth-token": localStorage.getItem("token"),
      },
    });
    const json = await response.json();
    // Remove the deleted note from state
setnotes(notes.filter((note) => note._id !== id));
  };
  
// EDIT A NODE------------------------------------------------------------------------------------------------------------------------------------------

  const editnote = async (id, title, description, tag) => {
    const response = await fetch(`${host}/api/notes/update/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "auth-token": localStorage.getItem("token"),
      },
      body: JSON.stringify({title, description, tag}),
    });
    await response.json();
    let newNotes = JSON.parse(JSON.stringify(notes));
    for (let index = 0; index < newNotes.length; index++) {
      const element = newNotes[index];
      if (element._id === id) {
        newNotes[index].title = title;
        newNotes[index].description = description;
        newNotes[index].tag = tag;
        break;
      }
    }
    setnotes(newNotes);
  };


 // OTHERS-------------------------------------------------------------------------------------------------------------------------------
 
  return (
    <notecontext.Provider value={{ notes, addnote, deletenote, editnote,getnotes }}>
      {props.children}
    </notecontext.Provider>
  );
};

export default Notestate;
